
import { useToast } from "@/components/ui/use-toast";
import { ProductCard } from "./ProductCard";
import { donationData } from "./donation-data";
import { useState, useEffect } from "react";

export function ProductList() {
  const { toast } = useToast();
  const [openItem, setOpenItem] = useState<string | undefined>();
  const [isMobile, setIsMobile] = useState(false);

  // Check if we're on mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  const handlePurchase = (name: string) => {
    toast({
      title: "Added to Cart",
      description: `${name} has been added to your cart.`,
      duration: 3000,
    });
  };

  const handleAccordionChange = (value: string | undefined, rowIndex: number) => {
    // When opening an item on mobile, scroll to that item
    if (value && isMobile) {
      setTimeout(() => {
        const element = document.getElementById(`product-card-${rowIndex}`);
        if (element) {
          const yOffset = -100; // Adjust this value to determine the space from top
          const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({top: y, behavior: 'smooth'});
        }
      }, 100);
    }

    if (value) {
      // When opening an item, calculate which items are in the same row
      const itemsPerRow = window.innerWidth >= 1280 ? 4 : window.innerWidth >= 1024 ? 3 : window.innerWidth >= 768 ? 2 : 1;
      const rowStart = Math.floor(rowIndex / itemsPerRow) * itemsPerRow;
      const rowEnd = rowStart + itemsPerRow;
      setOpenItem(`row-${rowStart}-${rowEnd}`);
    } else {
      setOpenItem(undefined);
    }
  };

  const isItemInOpenRow = (index: number) => {
    if (!openItem) return false;
    const [, rowStart, rowEnd] = openItem.split('-').map(Number);
    return index >= rowStart && index < rowEnd;
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
      {Object.entries(donationData).map(([slug, product], index) => (
        <ProductCard
          key={product.id}
          id={`product-card-${index}`}
          product={{
            ...product,
            slug: slug as any,
            isDonation: true
          }}
          onPurchase={handlePurchase}
          isOpen={isItemInOpenRow(index)}
          onOpenChange={(value) => handleAccordionChange(value, index)}
        />
      ))}
    </div>
  );
}
